import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import storage from 'redux-persist/lib/storage'
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  createTransform,
} from 'redux-persist'
import login from './slice/loginSlice'
import init from './slice/initSlice'
import loader from './slice/loaderSlice'
import modal from './slice/modalSlice'
import patient from './slice/patientSlice'
import platformMode from './slice/platformModeSlice'
import { baseApi } from './services/baseApi'
import { listenForOtherTabsInvalidation } from './crossTabInvalidation'

import { combineReducers } from 'redux'

const rootReducer = combineReducers({
  loader,
  modal,
  login,
  init,
  patient,
  platformMode,
  [baseApi.reducerPath]: baseApi.reducer,
})

const initSavedBucketsTransform = createTransform(
  (inboundState: any) => ({
    ...inboundState,
    savedBuckets: [],
  }),
  (outboundState: any) => ({
    ...outboundState,
    savedBuckets: [],
  }),
  { whitelist: ['init'] },
)

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['modal', 'platformMode'],
  transforms: [initSavedBucketsTransform],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }).concat(baseApi.middleware),
})

setupListeners(store.dispatch)
listenForOtherTabsInvalidation((tags) => store.dispatch(baseApi.util.invalidateTags(tags)))

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
